import { PropagateLoader } from 'react-spinners'

import { cn } from '@/utils/cn'

interface Props {
    absolute?: boolean
    navVisible?: boolean
    className?: string
    size: 'sm' | 'md'
}

export default function Spinner({ absolute, navVisible, size, className }: Props) {
    return (
        <div
            className={cn(
                {
                    'absolute-center': absolute,
                    'ml-24': navVisible,
                },
                className,
            )}
        >
            <PropagateLoader size={size === 'sm' ? 15 : 25} color="hsl(var(--primary))" />
        </div>
    )
}
